import axios from "axios";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`, withCredentials: true, timeout: 60000 });

const csrf = () => document.cookie.split("; ").find((c) => c.startsWith("brain_csrf="))?.split("=")[1] || "";

adminApi.interceptors.request.use((cfg) => {
  if (cfg.method !== "get") cfg.headers["X-CSRF-Token"] = csrf();
  return cfg;
});

let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) onUnauthorized();
    return Promise.reject(err);
  }
);

export function parseError(err) {
  if (!err?.response) return { message: "Network error — nothing was saved. Your edits are still here; check your connection and try again.", fields: {} };
  const d = err.response.data?.detail;
  if (Array.isArray(d)) {
    const fields = {};
    const general = [];
    d.forEach((e) => (e?.field && e.field !== "status" ? (fields[e.field] = e.msg) : general.push(e?.msg || String(e))));
    return { message: general.join(" ") || "Please correct the highlighted fields.", fields };
  }
  if (err.response.status === 401) return { message: "Your session has expired. Your edits are kept on this device — sign in again to save them.", fields: {} };
  return { message: typeof d === "string" ? d : "Something went wrong. Nothing was saved.", fields: {} };
}

export const resolveImage = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export async function download(path, params) {
  const r = await adminApi.get(path, { params, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "download";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const TZ = "Asia/Kolkata";
export const isoToIstInput = (iso) => {
  if (!iso) return "";
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
      .formatToParts(new Date(iso))
      .map((x) => [x.type, x.value])
  );
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
export const istInputToDate = (v) => (v ? new Date(`${v}:00+05:30`) : null);
